var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service_info type4"},[_c('div',{staticClass:"title"},[_vm._v("관련 서비스")]),_c('ul',{staticClass:"servie_list"},_vm._l((_vm.serviceLinkData),function(data,idx){return _c('li',{key:idx,on:{"click":function($event){return _vm.serviceLink(data.mingle_link_url)}}},[_vm._v(" "+_vm._s(data.mingle_link_title)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }